<button
  class="button"
  [class]="'button--' + variant()"
  [type]="type()"
  [disabled]="disabled() || loading()"
  [attr.aria-busy]="loading() ? 'true' : null"
  [attr.form]="form() || null"
>
  @if (loading()) {
  <span
    class="button__spinner"
    aria-hidden="true"
  ></span>
  }
  <ng-content />
</button>
